/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_TargetInputs */

const cs_client_merge_target = /** @type {(inputs: Client_Merge_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cílový klient`)
};

const en_client_merge_target = /** @type {(inputs: Client_Merge_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target client`)
};

/**
* | output |
* | --- |
* | "Target client" |
*
* @param {Client_Merge_TargetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_target = /** @type {((inputs?: Client_Merge_TargetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_TargetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_target(inputs)
	return cs_client_merge_target(inputs)
});